import { render, staticRenderFns } from "./SecondPotParams.vue?vue&type=template&id=2a54264e&scoped=true"
import script from "./SecondPotParams.vue?vue&type=script&lang=js"
export * from "./SecondPotParams.vue?vue&type=script&lang=js"
import style0 from "./SecondPotParams.vue?vue&type=style&index=0&id=2a54264e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a54264e",
  null
  
)

export default component.exports